export const defaultInvoiceValidation = {
    series: true,
    seriesPrefix: true,
    number: true,
    dateOfIssueUtc: true,
    dateOfSaleUtc: true,
    seller: {
        name: undefined,
        nip: {
            nip: undefined
        },
        address: {
            country: true,
            city: undefined,
            street: undefined,
            houseNumber: undefined,
            zipCode: undefined
        }
    },
    buyer: {
        name: undefined,
        isCompany: undefined,
        nip: {
            nip: undefined
        },
        address: {
            country: true,
            city: undefined,
            street: undefined,
            houseNumber: undefined,
            zipCode: undefined
        }
    },
    placeOfIssue: undefined,
    items: [ { id: "dummy_line_item", validation: true, validationHideError: true } ]
  }

export const setSellerValidationObjectValuesTo = (setInvoiceValidation, newValue) => {
    setInvoiceValidation(draft => {      
      draft.seller.name = newValue;
      draft.seller.nip.nip = newValue;
      draft.seller.address.country = newValue;
      draft.seller.address.city = newValue;
      draft.seller.address.street = newValue;
      draft.seller.address.houseNumber = newValue;
      draft.seller.address.zipCode = newValue;
    });
};

export const setBuyerValidationObjectValuesTo = (setInvoiceValidation, newValue) => {
  setInvoiceValidation(draft => {   
    draft.buyer.isCompany = newValue;
    draft.buyer.name = newValue;
    draft.buyer.nip.nip = newValue;
    draft.buyer.address.country = newValue;
    draft.buyer.address.city = newValue;
    draft.buyer.address.street = newValue;
    draft.buyer.address.houseNumber = newValue;
    draft.buyer.address.zipCode = newValue;
  });
};

export const setInvoiceValidationValuesTo = (setInvoiceValidation, newValue) => {
  setInvoiceValidation(draft => {   
    draft.series = newValue;
    draft.number = newValue;
    draft.dateOfIssueUtc = newValue;
    draft.dateOfSaleUtc = newValue;
    setSellerValidationObjectValuesTo(setInvoiceValidation, newValue);
    setBuyerValidationObjectValuesTo(setInvoiceValidation, newValue);
    draft.placeOfIssue = newValue;
  });
};

export const setInvoiceValidationData = (setInvoiceValidation, data) => {
  setInvoiceValidation(draft => {
    draft.series = data.series;
    draft.number = data.number;
    draft.dateOfIssueUtc = data.dateOfIssueUtc;
    draft.dateOfSaleUtc = data.dateOfSaleUtc;
    draft.seller = data.seller;
    draft.buyer = data.buyer;
    draft.items = data.items;
    draft.placeOfIssue = data.placeOfIssue;
  });
}
